__turbopack_context__.v({
  "activeItem": "dropdown-module-scss-module__cqLMqG__activeItem",
  "dropdownContainer": "dropdown-module-scss-module__cqLMqG__dropdownContainer",
  "dropdownItem": "dropdown-module-scss-module__cqLMqG__dropdownItem",
  "dropdownList": "dropdown-module-scss-module__cqLMqG__dropdownList",
  "inputField": "dropdown-module-scss-module__cqLMqG__inputField",
  "inputOpen": "dropdown-module-scss-module__cqLMqG__inputOpen",
  "threeLineEllipse": "dropdown-module-scss-module__cqLMqG__threeLineEllipse",
});
